<div class="header-nav">
  <div class="header-nav__item" *ngIf="additionalAbout$ | async as additionalAbout">
    <a [routerLink]="['additional', additionalAbout.slug]" class="link link--underline-in h4">{{ additionalAbout.menuLabel }}</a>
  </div>
  <div class="header-nav__item" *ngIf="isShowActionsLink$ | async">
    <a routerLink="/actions" class="link link--underline-in h4" i18n="@@PromotionActions">Promotion actions</a>
  </div>
  <div class="header-nav__item _divider" *ngIf="isShowLangSwitch">
    <app-lang-switch></app-lang-switch>
  </div>
  <div class="header-nav__item _divider " *ngIf="additionalPages$ | async as pages">
    <div class="header-nav__group">
      <button class="link link--underline-in h4" i18n="@@AdditionalPagesMenu">More</button>
      <div class="header-nav__group-content" >
        <a
          class="header-nav__group-item link link--underline-in h4"
          [routerLink]="['additional', page.slug]"
          *ngFor="let page of pages"
          [title]="page.menuLabel"
        >
          {{ page.menuLabel }}
        </a>
      </div>
    </div>
  </div>
</div>
